import { createNamespacedHelpers } from 'vuex';
import BaseStore from '@/store';
import actions from './customers.actions.js';
import getters from './customers.getters.js';
import mutations from './customers.mutations.js';
import state from './customers.state.js';

BaseStore.registerModule('customers', {
	namespaced: true,
	state,
	actions,
	getters,
	mutations
});

export default BaseStore;

let { mapState, mapGetters, mapMutations, mapActions } = createNamespacedHelpers('customers');

export {
	mapState,
	mapGetters,
	mapMutations,
	mapActions
};
